import routes from '../../../routes';
import { IconType } from '../../../components/Icon/Icon';

export interface MenuItem {
    name: string;
    link: string;
    icon: IconType;
}

const menuItems: MenuItem[] = [
    {
        name: 'location_search',
        link: routes.APP.DASHBOARD,
        icon: 'house',
    },
    {
        name: 'projects',
        link: routes.APP.PROJECTS.ROOT,
        icon: 'sun',
    },
];

export default menuItems;
